module.exports = __webpack_public_path__ + "static/media/carro.25fcfe1f.svg";